"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveScopedBinding = void 0;
const getSelf_1 = require("../../common/calculations/getSelf");
const resolveScoped_1 = require("./resolveScoped");
const resolveScopedBinding = (resolve) => (0, resolveScoped_1.resolveScoped)(getSelf_1.getSelf, resolve);
exports.resolveScopedBinding = resolveScopedBinding;
//# sourceMappingURL=resolveScopedBinding.js.map